module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-area-5af22c1bcd606425702a3c12fdff5236.svg&quot;;"